import React from "react";
import { Youtube, Instagram, Twitch } from "lucide-react";

export default function SocialIcon({ name, size = 17, className = "" }) {
  const common = { width: size, height: size, className, "aria-hidden": true };
  if (name === "youtube") return <Youtube size={size} className={className} />;
  if (name === "instagram") return <Instagram size={size} className={className} />;
  if (name === "twitch") return <Twitch size={size} className={className} />;
  if (name === "spotify")
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" {...common}>
        <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm4.586 14.424a.623.623 0 01-.857.207c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.215c3.809-.87 7.077-.496 9.712 1.115a.623.623 0 01.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.785-2.13-9.965-1.166a.78.78 0 11-.452-1.492c3.632-1.102 8.147-.568 11.232 1.329a.78.78 0 01.257 1.072zm.105-2.835C14.692 8.95 9.375 8.775 6.37 9.688a.935.935 0 11-.542-1.79c3.45-1.047 9.322-.845 13.0 1.338a.935.935 0 11-.955 1.607z" />
      </svg>
    );
  if (name === "tiktok")
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" {...common}>
        <path d="M16.5 3c.3 2.03 1.46 3.24 3.5 3.37v2.36c-1.18.12-2.2-.26-3.4-.98v4.37c0 5.56-6.06 7.3-8.49 3.3-1.56-2.57-.6-7.08 4.44-7.26v2.49c-.38.06-.8.16-1.17.29-1.13.38-1.77 1.1-1.59 2.36.34 2.42 4.78 3.13 4.41-1.6V3h2.29z" />
      </svg>
    );
  return null;
}
